// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._container_1v0ql_2 {
	margin-top: auto;
	padding: var(--default-grid-baseline);
}
._header_1v0ql_7 {
	margin-block: 0 var(--default-grid-baseline);
	margin-inline: var(--default-grid-baseline);
}
._content_1v0ql_12 {
	display: block;
	padding: 10px;

	/* prevent scrolled contents from stopping too early */
	margin-bottom: calc(-1 * var(--default-grid-baseline));

	/* restrict height of settings and make scrollable */
	max-height: 300px;
	overflow-y: auto;
}
._animationActive_1v0ql_24 {
	transition-duration: var(--animation-slow);
	transition-property: max-height, padding;
	overflow-y: hidden !important;
}
._animationStop_1v0ql_30 {
	max-height: 0 !important;
	padding: 0 10px !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSettings-BDc6Mtek.css"],"names":[],"mappings":";AACA;CACC,gBAAgB;CAChB,qCAAqC;AACtC;AACA;CACC,4CAA4C;CAC5C,2CAA2C;AAC5C;AACA;CACC,cAAc;CACd,aAAa;;CAEb,sDAAsD;CACtD,sDAAsD;;CAEtD,oDAAoD;CACpD,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,0CAA0C;CAC1C,wCAAwC;CACxC,6BAA6B;AAC9B;AACA;CACC,wBAAwB;CACxB,0BAA0B;AAC3B","sourcesContent":["\n._container_1v0ql_2 {\n\tmargin-top: auto;\n\tpadding: var(--default-grid-baseline);\n}\n._header_1v0ql_7 {\n\tmargin-block: 0 var(--default-grid-baseline);\n\tmargin-inline: var(--default-grid-baseline);\n}\n._content_1v0ql_12 {\n\tdisplay: block;\n\tpadding: 10px;\n\n\t/* prevent scrolled contents from stopping too early */\n\tmargin-bottom: calc(-1 * var(--default-grid-baseline));\n\n\t/* restrict height of settings and make scrollable */\n\tmax-height: 300px;\n\toverflow-y: auto;\n}\n._animationActive_1v0ql_24 {\n\ttransition-duration: var(--animation-slow);\n\ttransition-property: max-height, padding;\n\toverflow-y: hidden !important;\n}\n._animationStop_1v0ql_30 {\n\tmax-height: 0 !important;\n\tpadding: 0 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
